var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "client-staff" },
    [
      _c(
        "div",
        { staticClass: "client-search" },
        [
          _c("el-input", {
            staticClass: "base-msg-input",
            attrs: {
              size: "mini",
              "suffix-icon": "el-icon-search",
              placeholder: "客户姓名/卡号/手机号",
              clearable: ""
            },
            on: { blur: _vm.onInputBlur, clear: _vm.onInputBlur },
            model: {
              value: _vm.formInline.ctmNameOrPhoneOrCtmCode,
              callback: function($$v) {
                _vm.$set(_vm.formInline, "ctmNameOrPhoneOrCtmCode", $$v)
              },
              expression: "formInline.ctmNameOrPhoneOrCtmCode"
            }
          }),
          _c("el-date-picker", {
            staticStyle: { width: "240px", "margin-right": "10px" },
            attrs: {
              size: "mini",
              type: "datetimerange",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              "range-separator": "~",
              editable: false,
              "start-placeholder": "添加日期",
              "end-placeholder": "添加日期",
              clearable: "",
              "default-time": ["00:00:00", "23:59:59"]
            },
            on: { change: _vm.selectTime },
            model: {
              value: _vm.dateTime,
              callback: function($$v) {
                _vm.dateTime = $$v
              },
              expression: "dateTime"
            }
          }),
          _c(
            "el-tag",
            {
              staticClass: "add-per-input",
              attrs: {
                title: "选择添加人",
                closable: this.searchMenNames.length === 0 ? false : true,
                type: "medium",
                effect: "plain"
              },
              on: {
                close: _vm.searchCloseTag,
                click: function($event) {
                  return _vm.clickAddMember(true)
                }
              }
            },
            [
              _vm.searchMenNames.length === 0
                ? _c("span", [_vm._v("选择添加人")])
                : _vm._e(),
              _vm._l(_vm.searchMenNames, function(item, index) {
                return _c("span", { key: index }, [
                  _vm._v(_vm._s(item.name)),
                  _vm.searchMenNames.length > 1
                    ? _c("span", [_vm._v(",")])
                    : _vm._e()
                ])
              })
            ],
            2
          ),
          _c("el-cascader", {
            attrs: {
              placeholder: "选择标签",
              size: "mini",
              options: _vm.options,
              props: _vm.props,
              "show-all-levels": false,
              clearable: "",
              "collapse-tags": ""
            },
            on: { blur: _vm.selectTags },
            model: {
              value: _vm.tagsData,
              callback: function($$v) {
                _vm.tagsData = $$v
              },
              expression: "tagsData"
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  ref: "cusChatTable",
                  staticStyle: { "font-size": "13px" },
                  attrs: {
                    size: "small",
                    data: _vm.tableData,
                    fit: "",
                    "highlight-current-row": "",
                    align: "center",
                    "header-cell-style": { background: "#F9F9F9" },
                    height: "calc(100vh - 235px)"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "index", "min-width": "50" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "customerName",
                      label: "客户",
                      "min-width": "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { padding: "0" },
                                        attrs: { span: 30 }
                                      },
                                      [
                                        _c("el-avatar", {
                                          attrs: {
                                            size: "medium",
                                            shape: "square",
                                            src: scope.row.avatar
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("el-col", { attrs: { span: 70 } }, [
                                      scope.row.ctmName != null
                                        ? _c("div", [
                                            _vm._v(_vm._s(scope.row.ctmName))
                                          ])
                                        : _c("div", [_vm._v("--")]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            color: "#a09f9fc9",
                                            "font-size": "12px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(scope.row.name) + " "
                                          ),
                                          scope.row.type == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(70, 189, 10)"
                                                  }
                                                },
                                                [_vm._v(" @微信")]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(8, 168, 231)"
                                                  }
                                                },
                                                [_vm._v(" @企业微信")]
                                              )
                                        ]
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "添加时间",
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "userName",
                      label: "添加人",
                      "min-width": "120"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "usageScenario",
                      label: "客户标签",
                      "min-width": "200"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              _vm._l(scope.row.tagIdList, function(item) {
                                return _c(
                                  "el-tag",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.tagName != null,
                                        expression: "item.tagName!=null"
                                      }
                                    ],
                                    key: item.tagId,
                                    staticStyle: { margin: "5px 4px 0 0" },
                                    attrs: { size: "small" }
                                  },
                                  [_vm._v(" " + _vm._s(item.tagName) + " ")]
                                )
                              }),
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c("StaffTree", {
        attrs: {
          title: "添加成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }